/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { ConfigDisplaySignalDetectionToggle_ConfigFragmentDoc } from './ConfigDisplaySignalDetection.graphql';
import { UseConfigPowerToggle_ConfigFragmentDoc } from './useConfigPowerToggle.graphql';
import { ConfigDisplayBatteryManagement_ConfigFragmentDoc } from './ConfigDisplayBatteryManagement.graphql';
export type ConfigPowerSettingsSection_ConfigFragment = { __typename: 'ConfigurationModel', id: string, deviceSdk?: { __typename: 'ConfigDeviceSdk', sdk: string, version: string } | null, power?: { __typename: 'ConfigPowerState', reportedAt: any, reported: Types.ConfigPower } | null, autoRestart?: { __typename: 'ConfigAutoRestartState', reported: { __typename: 'ConfigAutoRestart', switch: string, time?: string | null } } | null, signalDetection?: { __typename: 'ConfigSignalDetectionState', reported: boolean } | null, battery?: { __typename: 'ConfigBatteryState', reported: { __typename: 'ConfigBattery', powerManagement: string } } | null, recommendedSettings?: { __typename: 'ConfigRecommendedSettingsState', reported: { __typename: 'ConfigRecommendedSettings', recommended: boolean, warnings: Array<{ __typename: 'ConfigSettingWarning', code: string, severity: Types.ConfigSettingWarningSeverity }> } } | null };

export const ConfigPowerSettingsSection_ConfigFragmentDoc = gql`
    fragment ConfigPowerSettingsSection_config on ConfigurationModel {
  id
  deviceSdk {
    sdk
    version
  }
  power {
    reportedAt
  }
  autoRestart {
    reported {
      switch
      time
    }
  }
  ...ConfigDisplaySignalDetectionToggle_config
  ...useConfigPowerToggle_config
  ...ConfigDisplayBatteryManagement_config
}
    ${ConfigDisplaySignalDetectionToggle_ConfigFragmentDoc}
${UseConfigPowerToggle_ConfigFragmentDoc}
${ConfigDisplayBatteryManagement_ConfigFragmentDoc}`;